import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AddressListMaintenanceDto } from './AddressListMaintenanceDto';
import { AddressItemMaintenanceDto } from './AddressItemMaintenanceDto';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { SignatureDto } from '@shared/src/dtos/signature/SignatureDto';
import { Observable } from 'rxjs';

@Injectable()
export class AddressMaintenanceController extends BaseMaintenanceController<AddressListMaintenanceDto, AddressItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "address");
    }

    public getResourceRoot(): string {
        return "ADDRESS";
    }

    public buildUrl(uri: string): string {
        return "/activity/address" + uri;
    }

    public getSignature(addressId: number): Observable<SignatureDto> {
        return this.get(this.getBaseUrl() + "/signature/" + addressId);
    }

    public saveSignature(addressId: number, data: SignatureDto): Observable<SignatureDto> {
        return this.post(this.getBaseUrl() + "/savesignature/" + addressId, data, "saveSignature");
    }
}